import { render } from "./App.vue?vue&type=template&id=0f1d8f1c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0f1d8f1c&lang=scss"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__